import type { ClassValue } from 'clsx';

import { new__cn as cn } from './cn';

export default function createTwStyle<TProps extends Dictionary>() {
  return function <
    TStyles extends Dictionary<ClassValue | ((props: TProps) => ClassValue)>,
  >(styles: TStyles): (props: TProps) => { [K in keyof TStyles]: string } {
    return (props: TProps) =>
      Object.entries(styles).reduce(
        (acc, cur) => {
          return {
            ...acc,
            [cur[0]]: cn(typeof cur[1] === 'function' ? cur[1](props) : cur[1]),
          };
        },
        {} as {
          [K in keyof TStyles]: string;
        },
      );
  };
}

export { createTwStyle };
